<template>
  <div class="vei-ger">
    <template v-if='statusGeral !== ""'>
      <RF-Status :cpntStatus='statusGeral' :cpntTamanho='5'></RF-Status>
    </template>

    <template v-else-if='statusGeral === ""'>
      <div class="cabecalho">
        <App-Filtros
        :cpntMontarCampoF="veiGerTabOnBuscarOptionsFiltroF"
        :cpntMontarCampoO="veiGerTabOnBuscarOptionsFiltroO"
        :cpntMontarCampoV="veiGerTabOnBuscarOptionsFiltroV"
        :cpntFiltroPredefinido="{ f: 'placa', o: '%', v: '' }"

        :cpntInputCoringa="{}"
        :cpntApiTabPer="tabper"
        @BUSCAR='veiGerTabBuscarLinhas'
        ref="filtros">
          <div class="botao" v-if="tabper !== '' && $route.name !== 'veiculo_exc'">
            <App-Button :data-time="time" 
              :cpntId='botao.id'
              :cpntStatus='botao.status' 
              :cpntIcone='botao.icone'
              :cpntTexto='botao.texto'
              :cpntClass='botao.class'
              :cpntDisabled="botao.disabled"
              @onClick='botao.onClick'
            ></App-Button>
          </div>
        </App-Filtros>
      </div>

      <!-- SETA A TABELA -->
      <div class="tabela">
        <App-Tabela
        :cpntSetarFiltros="veiGerTabSetarFiltros"
        :cpntMontarFiltros="veiGerTabMontarFiltros"
        :cpntMontarWhere="veiGerTabTabelaMontarWhere"
        :cpntCheckbox="checkbox"
        :cpntColuna="colunas"
        :cpntLinha="linha"
        :cpntMostrarMper="[ '', null, undefined ].indexOf(this.cpntSelecionar) !== -1"
        :cpntBotaoExportar="exportar"
        :cpntBotaoExcluir="botaoExcluir"
        :cpntBotaoEditar="botaoEditar"
        :cpntSetarValores="veiGerTabSetarLinhas"
        :cpntApiTabPer="tabper"
        :cpntApiTabPerOrder="tabPerOrder"
        :cpntApiRouter="route"
        :cpntApiWhere="where"
        :cpntApiMethods="'POST'"
        :cpntApiEstruturaQueryGet="estruturaQueryGet"
        @TABELA_MARCAR_CHECKBOX='veiGerTabMarcarCheckbox'
        ref="tabela">
          <!-- COLOCA FRASE SOBRE O TOP DA TABELA -->
          <template slot="cabecalho" v-if="$route.name === 'veiculo_exc'">
            <div style="color: red; font-weight: bold; text-align: center; font-size: var(--font-base-soma-12);">
              Os registros abaixo estão excluídos / desativados.
            </div>
          </template>

          <!-- BOTAO REATIVAR REGISTRO EXCLUIDO -->
          <template slot="botoes" v-if="[ '', null, undefined ].indexOf(botaoReativar) === -1">
            <App-Button :cpntIcone="'reativar'" :cpntStatus="botaoReativar !== 'carregando' ? '' : 'carregando'" :cpntClass="'btn btn-info btn-sm'" :cpntExplica="{ mensagem: 'Selecione os contatos desejados para serem reativados.' }" @onClick='() => { botaoReativar() }'>
            </App-Button>
          </template>

          <!-- COLUNA PLACA -->
          <template v-slot:col_placa="{ linha }">
            <App-Button :cpntClass="[ 'btn', 'btn-default', 'bt-link-cadastro' ]" @onClick='() => { veiGerTabAbrirCadastro("veiculo", linha.id) }'>
              <span v-html="linha.placa"></span>
            </App-Button>
          </template>

          <!-- COLUNA PROPRIETARIO -->
          <template v-slot:col_id_con="{ linha }">
            <App-Button :cpntClass="[ 'btn', 'btn-default', 'bt-link-cadastro' ]" @onClick='() => { veiGerTabAbrirCadastro("contato", linha.id_con) }'>
              <!-- COLOCA O NOME DO CONTATO -->
              <span v-html="linha.id_con_nome"></span>

              <!-- VERIFICA SE É UMA PJ E SE TEM NOME FANTASIA -->
              <span v-if='linha.id_con_pessoa === "j" && linha.id_con_empresa !== ""' v-html="' (' + linha.id_con_empresa + ')'"></span>

              <!-- VERIFICA SE O CONTATO ESTA EXCLUIDO -->
              <b v-if='linha.id_con_status !== "1"' v-html="'[Excluído]'"></b>
            </App-Button>
          </template>

          <!-- COLUNA ULTIMA ALTERAÇÃO -->
          <template v-slot:col_last="{ linha }">
            <span v-html="linha.updated_user_usuario + '<br/>' + linha.updated_at_ptbr"></span>
          </template>

          <!-- SETA A COLUNA MODELO -->
          <template v-slot:col_id_mod="{ linha }">
            <span v-html="linha.id_mod_nome"></span>
          </template>

          <!-- SETA A COLUNA MARCA -->
          <template v-slot:col_id_mar="{ linha }">
            <span v-html="linha.id_mar_nome"></span>
          </template>

          <!-- AÇÃO -->
          <template v-slot:col_acao="{ linha }">
            <App-Button :cpntStatus='linha.botao_iniciar.status' :cpntTexto='linha.botao_iniciar.texto' :cpntClass='linha.botao_iniciar.class' @onClick='() => { linha.botao_iniciar.onClick("acao", linha) }'>
              <span v-html="linha.botao_iniciar.texto"></span>
            </App-Button>

            |

            <App-Button :cpntStatus='linha.botao_qtde.status' :cpntTexto='linha.botao_qtde.texto' :cpntClass='linha.botao_qtde.class' @onClick='() => { linha.botao_qtde.onClick("qtde", linha) }'>
              <span v-html="linha.botao_qtde.texto"></span>
            </App-Button>
          </template>

          <!-- SETA PARA SELECIONAR O REGISTRO -->
          <template v-slot:col_selecionar="{ linha, indexL }">
            <App-Button @onClick='() => { cpntSelecionar(linha, indexL) }' :cpntClass="'btn btn-primary btn-sm'" :cpntIcone="'selecionar'"></App-Button>
          </template>
        </App-Tabela>
      </div>
    </template>

    <!-- LOCAL AONDE SERÁ ABERTO O FORMULARIO -->
    <router-view :cpntFecharFormulario="veiGerTabFecharFormulario"></router-view>
  </div>
</template>

<style scoped>
.vei-ger {
  padding-top: 20px;
}
</style>

<style>
  .vei-ger > .tabela > table > tbody > tr > td.col_placa > div > span > button,
  .vei-ger > .tabela > table > tbody > tr > td.col_id_con > div > span > button {
    text-align: left;
    font-size: inherit !important;
  }
  .vei-ger > .tabela > table > tbody > tr > td.col_acao {
    width: 140px;
  }
    .vei-ger > .tabela > table > tbody > tr > td.col_acao > div > span > button:first-child {
      min-width: 75px;
    }
    .vei-ger > .tabela > table > tbody > tr > td.col_acao > div > span > button:last-child {
      min-width: 41px;
    }
</style>

<script>
  export default {
    props: {
      cpntFiltros: {
        required: false,
        default: function () {
          return null
        }
      },
      cpntSelecionar: {
        required: false,
        default: function () {
          return null
        }
      }
    },
    components: {
      'App-Filtros': () => import('@/components/_geral/Filtros.vue'),
      'App-Icones': () => import('@/components/rf-geral/icones/RF-Icones.vue'),
    },
    data: function () {
      return {
        time: '',
        statusGeral: 'carregando',
        checkbox: [],
        tabper: 'Veiculo',
        route: '/veiculo/get',
        botao: {
          status: '',
          id: 'vei-ger--novo',
          texto: 'Novo Veículo',
          class: [ 'btn', 'btn-info' ],
          mostrar: true,
          onClick: () => {
            switch (this.$route.name) {
              case 'veiculo_gere':
                this.$router.push({ name: 'veiculo_form', params: { id: 0 } })
                break
            
              default:
                // SETA OS PARAMETROS QUE SERÁ ENVIADO
                var params = { editar: true, tipo: 'veiculo', id: 0 }

                // SETA O CALLBACK QUE DEVE EXECUTAR AO FECHAR O FORMULARIO
                params.callback = (atualizar, id, dados) => {
                  if (atualizar === true && [ '', null, undefined ].indexOf(this.cpntSelecionar) === -1) {
                    this.cpntSelecionar(dados)
                  }
                }

                // CHAMA A FUNÇÃO PARA INFORMAR QUE A ROTA FOI ATUALIZADA
                this.$store.commit('SET_ABRIR_CADASTRO_VET', params)
                break
            }
          }
        },
        colunas: [],
        linha: [],
        fazerOrdenacao: true,
        tabPerOrder: [
          { id: '0', nome: 'Última Alteração',                chave: 'updated_at',  order: 'desc' },
          { id: '1', nome: 'Código Crescente',                chave: 'id',          order: 'asc' },
          { id: '2', nome: 'Ordem Alfabética Placa Veículo',  chave: 'placa',       order: 'asc' },
          { id: '3', nome: 'Código Decrescente',              chave: 'id',          order: 'desc' },
          { id: '4', nome: 'Ordem Alfabética Contato',        chave: 'id_con_nome', order: 'asc' },
        ],  
        where: {},
        estruturaQueryGet: [
          [ 'type', 'countAll', 'limit', 'field', 'field_virtual', 'where', 'order' ]
        ],
        botaoEditar: undefined,
        botaoExcluir: undefined,
        botaoReativar: undefined,
        exportar: undefined
      }
    },
    mounted: function () {
      // SETA O STATUS DA PAGINA
      this.veiGerTabSetarStatusGeral('carregando')
      
      // INICIA O CARREGAMENTO DA TELA
      this.veiGerTabBuscarLinhas()
    },
    methods: {
      veiGerTabFecharFormulario: function (atualizar) {
        if (atualizar === true) {
          this.veiGerTabBuscarLinhas()
        }
      },
      veiGerTabBuscarLinhas: function () {
        // INICIA A VARIAVEL DOS BOTÕES
        this.botaoEditar = null
        this.botaoExcluir = null
        this.botaoReativar = null
        this.exportar = null

        // VERIFICA SE ESTÁ PAGINA DEVE APRESENTAR O BOTÃO EXCLUIR
        if (this.$route.name !== 'veiculo_exc') {
          // VERIFICA SE PODE EXCLUIR VENDA OU NÃO
          if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 8 ], null, [ 14 ], null, [ 330 ], null, false) === true) {
            this.botaoEditar = this.veiGerTabEditar
          }
  
          // VERIFICA SE PODE EXCLUIR VENDA OU NÃO
          if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 8 ], null, [ 14 ], null, [ 331 ], null, false) === true) {
            this.botaoExcluir = this.veiGerTabExcluir
          }

          // SETA O WHERE QUE DEVE REALIZAR
          this.where = { aAnd: [ { f: 'status', o: '=', v: '1' } ] }

          // SETA O MAPA PARA EXPORTAR
          this.exportar = {
            format: [ 'xlsx', 'pdf' ],
            search: true,
            // field: [
            //   { placa:                        'Placa' },
            //   { id_con_nome:                  'Proprietário' },
            //   { ref_modelo_id_marca_j_marca:  { a: 'Marca', prioridade: 1 } },
            //   { id_mar_nome:                  { a: 'Marca', prioridade: 2 } },
            //   { ref_modelo_j_modelo:          { a: 'Modelo', prioridade: 1 } },
            //   { id_mod_nome:                  { a: 'Modelo', prioridade: 2 } },
            //   { ano:                          'Ano' },
            //   { motor:                        'Motor' },
            //   { combus:                       'Combustível' },
            //   { cor:                          'Cor' },
            //   { km:                           'KM' },
            //   { updated_user_usuario:         'Alterado por' },
            //   { updated_at_ptbr:              'Última Alteração' }
            // ]
          }
        } else {
          // SETA O BOTÃO REATIVAR
          this.botaoReativar = this.veiGerTabReativar

          // SETA O WHERE QUE DEVE REALIZAR
          this.where = { aAnd: [ { f: 'status', o: '=', v: '0' } ] }
        }

        // REINICIA O VALOR DO CAMPO
        this.fazerOrdenacao = true

        // SETA AS COLUNAS DA TABELA
        var colunas = [
          { mPer: 3,  chave: 'id',                                export: { fields: {} }, fieldsApi: {}, tipo: 'checkbox' },
          { mPer: 0,  chave: 'id',      nome: 'Cód.',             export: { fields: {} }, fieldsApi: {} },
          { mPer: 2,  chave: 'placa',   nome: 'Placa',            export: { fields: {} }, fieldsApi: { id: null, placa: null, ref_modelo: { j: { j_modelo: null, id_marca: { j: { j_marca: null } } } }, updated_at: null } },
          { mPer: 2,  chave: 'id_con',  nome: 'Proprietário',     export: { fields: { id_con_nome: 'Proprietário' } }, fieldsApi: { id_con: { j: { nome: null, empresa: null, pessoa: null, status: null } } } },
          { mPer: 1,  chave: 'id_mar',  nome: 'Marca',            export: { fields: { ref_modelo_id_marca_j_marca:  { a: 'Marca', prioridade: 1 }, id_mar_nome: { a: 'Marca', prioridade: 2 } } }, fieldsApi: { id_mar: { j: { nome: null } } } },
          { mPer: 1,  chave: 'id_mod',  nome: 'Modelo',           export: { fields: { ref_modelo_j_modelo: { a: 'Modelo', prioridade: 1 }, id_mod_nome: { a: 'Modelo', prioridade: 2 } } }, fieldsApi: { id_mod: { j: { nome: null } } } },
          { mPer: 1,  chave: 'ano',     nome: 'Ano',              export: { fields: {} }, fieldsApi: { ano: null } },
          { mPer: 1,  chave: 'motor',   nome: 'Motor',            export: { fields: {} }, fieldsApi: { motor: null } },
          { mPer: 1,  chave: 'combus',  nome: 'Combustível',      export: { fields: {} }, fieldsApi: { combus: null } },
          { mPer: 1,  chave: 'cor',     nome: 'Cor',              export: { fields: {} }, fieldsApi: { cor: null } },
          { mPer: 1,  chave: 'km',      nome: 'KM',               export: { fields: {} }, fieldsApi: { km: null } },
          { mPer: 1,  chave: 'last',    nome: 'Última Alteração', export: { fields: { updated_user_usuario: 'Alterado por', updated_at_ptbr: 'Última Alteração' } }, fieldsApi: { updated_at: null, updated_user: { j: { usuario: null } } } },
          { mPer: 3,  chave: 'acao',    nome: 'Iniciar',          export: { fields: {} }, fieldsVir: [ 'venda_total_qtde' ] }
        ]

        // INCIA A VARIAVEL PARA REMOVER COLUNA
        var remover = []

        // REMOVE AS COLUNAS QUE NÃO DEVE APRESENTAR
        if (this.$route.name === 'veiculo_exc') {
          remover = remover.concat([ 'acao' ])
        }

        // VERIFICA A AÇÃO QUE DEVE REALIZAR
        if ([ '', null, undefined ].indexOf(this.cpntSelecionar) === -1) {
          // REMOVE AS COLUNAS NÃO UTILIZADAS
          remover = remover.concat([ 'id', 'acao' ])

          // REMOVE OS BOTOES DA TELA
          this.botaoEditar = null
          this.botaoExcluir = null
          this.botaoReativar = null

          // REMOVE A PAGINAÇÃO E A MINHA PERSONALIZAÇÃO
          this.estruturaQueryGet[0].concat([ 'SemPaginacao' ])

          // REOMVE PARA NÃO DAR ERRO 500
          this.estruturaQueryGet[0] = this.estruturaQueryGet[0].filter(item => [ 'order' ].indexOf(item) === -1)

          // CRIA UMA NOVA COLUNA PARA SELECIONAR
          colunas.unshift({ mPer: 3, chave: 'selecionar', nome: 'Selecionar' })
        }

        // REMOVE AS COLUNAS INFORMADAS
        if (remover.length >= 1) {
          colunas = colunas.filter(item => remover.indexOf(item.chave) === -1)
        }

        // SETA AS COLUNAS MONTADAS
        this.colunas = colunas

        // VERIFICA SE TEM QUE BUSCAR E ATUALIZAR A TABELA       
        if ([ '', null, undefined ].indexOf(this.$refs.tabela) === -1 || this.statusGeral === '') {
          this.veiGerTabReiniciar()
        } else {
          this.veiGerTabSetarStatusGeral('')
        }
      },
      veiGerTabBotaoAcao: function (tipo, linha) {
        switch (tipo) {
          case 'acao':
            this.$router.push({ name: 'venda_nova_id', params: { id: linha.id, tipo: 'veiculo' } })
            break

          case 'qtde':
            this.$store.state.OPEN_PAGE_CS(this.$router.resolve({ name: 'venda_busc', params: { cts: this.$store.state.token.cts, busca: window.btoa(JSON.stringify({ f: 'id_vei_placa', o: '=', v: linha.id })) } }).href, '_blank')
            break
        }
      },
      veiGerTabAbrirCadastro: function (tipo, id) {
        // SETA OS PARAMETROS QUE SERÁ ENVIADO
        var params = { editar: false, tipo: tipo, id: id }
        
        // VERIFICA SE FOI ENCONTRADO O NUMERO DO REGISTRO
        if ([ '', null, undefined ].indexOf(params.id) === -1) {
          // SETA O CALLBACK QUE DEVE EXECUTAR
          params.callback = (atualizar) => {
            if (atualizar === true) {
              this.veiGerTabBuscarLinhas()
            }
          }

          // CHAMA A FUNÇÃO PARA INFORMAR QUE A ROTA FOI ATUALIZADA
          this.$store.commit('SET_ABRIR_CADASTRO_VET', params)
        }
      },
      veiGerTabTabelaMontarWhere: function (where) {
        // INICIA A VARIAVEL DE RETORNO
        var retorno = {}
        
        // CONVERTE A OPERAÇÃO RECEBIDA
        if (where.o === '%') {
          where.o = 'like'
        }

        // VERIFICA SE DEVE SETAR ALGUM VALOR
        switch (where.f) {
          case 'id_con_nome':
            if (where.o === '=') {
              retorno.where = { f: 'id_con', o: 'in', v: where.v.join() }
            } else {
              retorno.where = Object.assign(where, { m: 'contato', f: 'nome' })
            }
            break

          case 'id_con_cnpj':
          case 'id_con_cpf':
            retorno.where = { m: 'contato', f: 'cnpj_cpf', o: where.o, v: where.v }
            break

          case 'id_con_telefone':
            retorno.where = { aOr: [
              { m: 'contato', f: 'tel_res', o: where.o, v: where.v },
              { m: 'contato', f: 'tel_com', o: where.o, v: where.v },
              { m: 'contato', f: 'tel_cel', o: where.o, v: where.v }
            ] }
            break

          case 'id_con_email':
            retorno.where = { m: 'contato', f: 'email', o: where.o, v: where.v }
            break

          case 'id_con_estado':
            retorno.where = { m: 'contato', f: 'id_estado', o: where.o, v: where.v.join(',') }
            break

          case 'id_con_cidade':
            retorno.where = { m: 'contato', f: 'id_cidade', o: where.o, v: where.v.join(',') }
            break

          case 'id_con_tp_con':
            retorno.where = { m: 'contato', f: 'id_tp_con', o: where.o, v: where.v.join(',') }
            break

          case 'id_con_pessoa':
            retorno.where = { m: 'contato', f: 'pessoa', o: where.o, v: where.v }
            break

          case 'placa':
            if (where.o === '=') {
              retorno.where = { f: 'id_vei', o: 'in', v: where.v.join() }
            } else {
              retorno.where = Object.assign(where, { m: 'veiculo', f: 'placa' })
            }
            break

          case 'modelo':
            if (this.$store.state.flagBuscaVei === true) {
              retorno.where = { m: 'veiculo', f: 'ref_modelo', o: 'in', v: where.v.join() }
            } else {
              retorno.where = { m: 'veiculo', f: 'id_mod', o: 'in', v: where.v.join() }
            }
            break

          case 'marca':
            if (this.$store.state.flagBuscaVei === true) {
              retorno.where = { m: 'veiculo', f: 'ref_modelo', o: 'in', r: 'id', q: {
                model: 'vei_modelo',
                where: { f: 'id_marca', o: '=', v: where.v.join() }
              } }
            } else {
              retorno.where = { m: 'veiculo', f: 'id_mar', o: 'in', v: where.v.join() }
            }
            break

          case 'busca':
            // SETA OS DADOS QUE DEVE BUSCAR
            retorno.where = { aOr: [
              { o: 's.ft', v: where.v },
              { m: 'vei_modelo', o: 's.ft', v: where.v },
              { m: 'vei_marca', o: 's.ft', v: where.v },
              { m: 'vei_mod', o: 's.ft', v: where.v },
              { m: 'vei_mar', o: 's.ft', v: where.v },
              { m: 'contato', o: 's.ft', v: where.v }
            ] }

            // REINICIA O VALOR DO CAMPO
            this.fazerOrdenacao = false

            break
        }

        // SETA O FLAG DO CAMPO
        retorno.fazerOrdenacao = this.fazerOrdenacao

        // RETORNA O VALOR MONTADO
        return retorno
      },
      veiGerTabSetarStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      veiGerTabReiniciar: function (tentativa = 0) {
        if (tentativa <= 5) {
          if ([ '', null, undefined ].indexOf(this.$refs.tabela) === -1 && [ '', null, undefined ].indexOf(this.$refs.tabela.cpntTabelaReiniciar) === -1) {
            this.$refs.tabela.cpntTabelaReiniciar()
          } else {
            setTimeout(() => { this.veiGerTabReiniciar((tentativa + 1)) }, 100)
          }
        }
      },
      veiGerTabSetarFiltros: function (callback, filtros, tentativa = 0) {
        if (tentativa <= 5) {
          if ([ '', null, undefined ].indexOf(this.$refs.filtros) === -1 && [ '', null, undefined ].indexOf(this.$refs.filtros.cpntFiltroSetarFiltros) === -1) {
            // VERIFICA SE TEM QUE ALTERAR O FILTRO DO CAMPO
            if ([ '', null, undefined ].indexOf(this.cpntFiltros) === -1 && ([ '', null, undefined ].indexOf(filtros) !== -1 || (Array.isArray(filtros) === true && filtros.length === 0))) {
              filtros = this.cpntFiltros
            }

            // SETA O FILTRO NA TELA
            this.$refs.filtros.cpntFiltroSetarFiltros(callback, filtros)
          } else {
            setTimeout(() => { this.veiGerTabSetarFiltros(callback, filtros, (tentativa + 1)) }, 100)
          }
        }
      },
      veiGerTabMontarFiltros: function (callback, tentativa = 0) {
        if (tentativa <= 5) {
          if ([ '', null, undefined ].indexOf(this.$refs.filtros) === -1 && [ '', null, undefined ].indexOf(this.$refs.filtros.cpntFiltrosMontar) === -1) {
            this.$refs.filtros.cpntFiltrosMontar(callback)
          } else {
            setTimeout(() => { this.veiGerTabMontarFiltros(callback, (tentativa + 1)) }, 100)
          }
        }
      },
      veiGerTabSetarLinhas: function (vetor) {
        // SETA OS IDS SOLICITADOS
        for (var index in vetor) {
          // VERIFICA SE TEM MODELO NOVO SELECIONADO
          if ([ '', null, undefined ].indexOf(vetor[index].ref_modelo) === -1) {
            // SETA O MODELO ATUALIZADO
            vetor[index].id_mod = vetor[index].ref_modelo
            vetor[index].id_mod_nome = vetor[index].ref_modelo_j_modelo

            // SETA A MARCA ATUALIZADA
            vetor[index].id_mar = vetor[index].ref_modelo_id_marca
            vetor[index].id_mar_nome = vetor[index].ref_modelo_id_marca_j_marca
          }

          // SETA O BOTÃO VENDER NA TELA
          vetor[index].botao_iniciar = {
            status: '',
            texto: 'Vender',
            class: [ 'btn', 'btn-info', 'btn-sm' ],
            mostrar: true,
            onClick: this.veiGerTabBotaoAcao
          }

          // SETA A QUANTIDADE DE VENDAS CONTRADAS
          if ([ '', null, undefined ].indexOf(vetor[index].virtual_venda_total_qtde) !== -1) {
            vetor[index].virtual_venda_total_qtde = '0'
          }

          // SETA O BOTÃO DE QUANTIDADE
          vetor[index].botao_qtde = {
            status: '',
            texto: vetor[index].virtual_venda_total_qtde,
            class: [ 'btn', 'btn-warning', 'btn-sm' ],
            mostrar: true,
            onClick: this.veiGerTabBotaoAcao
          }
        }

        // SETA OS VALORES RECEBIDOS
        this.linha = vetor

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      veiGerTabMarcarCheckbox: function (checked, value) {
        // VERIFICA A AÇÃO QUE DEVE REALIZAR COM OS CHECKBOXS
        switch (checked) {
          case true:
            this.checkbox.push(value)
            break

          case false:
            this.checkbox = this.checkbox.filter(item => item !== value)
            break
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      veiGerTabReativar: function () {
        // REMOVE O FOCUS DE QUALQUER CAMPO
        if (document.activeElement !== document.body) {
          document.activeElement.blur()
        }

        // VERIFICA SE TEM REGISTRO PARA EDITAR
        if (this.checkbox.length === 0) {
          this.$store.state.msgWarn('WEB [406]: Selecione ao menos um registro para prosseguir.', 'warning')
        } else if (window.confirm('Deseja realmente reativar o(s) veículo(s) selecionados?')) {
          // SETA O STATUS DE CARREGANDO PARA O BOTÃO
          this.botaoReativar = 'carregando'

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // INICIA O FORMULARIO
          var formData = { j_id: JSON.stringify(this.checkbox) }

          // CHAMA FUNÇÃO PARA COMUNICAR COM API
          this.$store.state.comunicaAPI('/veiculo/reativar', 'PUT', formData, (apiSuccess) => {
            // PEGA O RETORNO RECEBIDO 
            var retorno = apiSuccess.lot[0]

            // APRESENTA A MENSAGEM DE SUCESSO
            this.$store.state.TRATAR_RET_LOT_API(apiSuccess)

            // VERIFICA O RESULTADO DA OPERAÇÃO
            switch (retorno.code) {
              case '200':
                // LIMPA OS CHECKBOX SELECIONADOS
                this.checkbox = []

                // MANDA ATUALIZAR A TABELA
                this.veiGerTabBuscarLinhas()
                break
            }

            // SETA O STATUS DE CARREGANDO PARA O BOTÃO
            this.botaoReativar = this.veiGerTabReativar

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          }, this.veiGerTabSetarStatusGeral)
        }
      },
      veiGerTabEditar: function () {
        // REMOVE O FOCUS DE QUALQUER CAMPO
        if (document.activeElement !== document.body) {
          document.activeElement.blur()
        }

        // VERIFICA SE TEM REGISTRO PARA EDITAR
        if (this.checkbox.length === 0) {
          this.$store.state.msgWarn('WEB [406]: Selecione ao menos um registro para prosseguir.', 'warning')
        } else if (this.checkbox.length >= 2) {
          this.$store.state.msgWarn('WEB [406]: Só é possivel editar um vei de cada vez.', 'warning')
        } else {
          // SETA OS IDS QUE DEVE EDITAR
          var ids = this.checkbox.length === 1 ? this.checkbox[0] : window.btoa(JSON.stringify(this.checkbox))

          // REDIRENCIONA PARA TELA SOLICITADA
          this.$router.push({ name: 'veiculo_form', params: { id: ids } })
        }
      },
      veiGerTabExcluir: function () {
        // REMOVE O FOCUS DE QUALQUER CAMPO
        if (document.activeElement !== document.body) {
          document.activeElement.blur()
        }

        // VERIFICA SE FOI SELECIONADO ALGUM REGISTRO
        if (this.checkbox.length === 0) {
          this.$store.state.msgWarn('WEB [406]: Selecione ao menos um registro para prosseguir.', 'warning')
        } else if (window.confirm('Deseja realmente excluir o(s) veículo(s) selecionado(s)?')) {
          // SETA O STATUS DE CARREGANDO PARA O BOTÃO
          this.botaoExcluir = 'carregando'

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // INICIA O FORMULARIO
          var formData = { j_id: JSON.stringify(this.checkbox) }

          // CHAMA FUNÇÃO PARA COMUNICAR COM API
          this.$store.state.comunicaAPI('/veiculo', 'DELETE', formData, (apiSuccess) => {
            // PEGA O RETORNO RECEBIDO 
            var retorno = apiSuccess.lot[0]

            // VERIFICA O RESULTADO DA OPERAÇÃO
            switch (retorno.code) {
              case '200':
                // LIMPA OS CHECKBOX SELECIONADOS
                this.checkbox = []

                // APRESENTA A MENSAGEM DE SUCESSO
                this.$store.state.TRATAR_RET_LOT_API(apiSuccess)

                // MANDA ATUALIZAR A TABELA
                this.veiGerTabBuscarLinhas()
                break

              default:
                this.$store.state.TRATAR_RET_LOT_API(apiSuccess)
                break
            }

            // SETA O STATUS DE CARREGANDO PARA O BOTÃO
            this.botaoExcluir = this.veiGerTabExcluir

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          }, this.veiGerTabSetarStatusGeral)
        }
      },
      veiGerTabOnBuscarOptionsFiltroF: function (callback) {
        // INICIA O VETOR PARA OS CAMPOS
        var vetor = {}

        // INICIA A VARIAVEL PARA ADICONAR A DEMANDA
        vetor.options = [
          { slot: 'veiculo',      group: 'Veículo' },
          { slot: 'contato',  group: 'Proprietário', mask: 'id_con' }
        ]

        // RETORNA O VALOR MONTADO
        callback(vetor)
      },
      veiGerTabOnBuscarOptionsFiltroO: function (callback) {
        // INICIA O VETOR PARA OS CAMPOS
        var vetor = {}
        
        // RETORNA O VALOR MONTADO
        callback(vetor)
      },
      veiGerTabOnBuscarOptionsFiltroV: function (callback) {
        // INICIA O VETOR PARA OS CAMPOS
        var vetor = {}
        
        // RETORNA O VALOR MONTADO
        callback(vetor)
      }
    },
    watch: {
      '$route': function (routeAtual, routeAnterior) {
        if (routeAnterior.name !== 'veiculo_form' && routeAtual.name !== 'veiculo_form') {
          // SETA O STATUS DA PAGINA
          this.veiGerTabSetarStatusGeral('carregando')

          // LIMPA OS VALORES PARA NÃO APRESENTAR ERRADO
          this.checkbox = []
          this.where = {}
          this.linha = []
          this.colunas = []

          // MANDA ATUALIZAR A TABELA
          setTimeout(() => { this.veiGerTabBuscarLinhas() }, 500)
        }
      }
    }
  }
</script>
